import { connect } from 'react-redux';
import { change as changeFormValue } from 'redux-form';
import CabinUpgrade from '../components/CabinUpgrade';
import { CABIN_UPGRADE } from '../../products';
import { getSelectedUpgrades, isProductSelected, isUpgradeSelected } from '../utils/utils';
const {
  name
} = CABIN_UPGRADE;
export const mapStateToProps = (state, _ref) => {
  let {
    form
  } = _ref;
  return {
    selectedCabinUpgrades: getSelectedUpgrades(form, name, state),
    isUpgradeSelected: isUpgradeSelected(form, name, state),
    isProductSelected: isProductSelected(form, name, state)
  };
};
export const mapDispatchToProps = (dispatch, _ref2) => {
  let {
    form
  } = _ref2;
  return {
    updateSelectedCabinUpgrades: _ref3 => {
      let {
        priceRaw,
        selectedUpgrades,
        value
      } = _ref3;
      return dispatch(changeFormValue(form, `${CABIN_UPGRADE.name}.value`, {
        value,
        selectedUpgrades,
        priceRaw
      }));
    }
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(CabinUpgrade);
//# sourceMappingURL=CabinUpgradeContainer.js.map